/**
 * 库存查询
 *
 * @author Shann <851188611@qq.com>
 * @version 1.0
 */
import React from "react";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import {Tabs, Card } from "antd";
import InventoryCompany from "./InventoryCompany/InventoryCompany";
import InventoryCustomer from "./InventoryCustomer/InventoryCustomer";
import "./InventoryQuery.less";
import InventoryQueryService from "../../api/InventoryQuerySerivce";
import IntoWarehouse from "../WarehouseManagement/Registration/Registration";

/**
 * 库存查询
 */
export default class InventoryQuery extends React.Component {
    state = {
        /**
         * 当前标签页索引
         */
        activeKey: "1",
        /**
         * 数据源
         */
        dataSource: [],
        /**
         * 记录总数
         */
        total: 0,
        /**
         * 分页
         */
        pagingQuery: {
            pageIndex: 1,
            pageSize: 10,
        },
    };

    componentDidMount() {
        this.queryList({
            type: this.state.activeKey === "1" ? 0 : 1,
        });
    }

    /**
     * 列表数据
     *
     * @param {Number} type 查询类型（0：公司库存，1：客户库存）
     */
    queryList = (queryParams) => {
        this.setState({
            loading: true,
        })
        const { transitCityIds } = this.state;
        if(transitCityIds&&transitCityIds.length>0){
            queryParams.transitCityIds = transitCityIds;
        }
        if(!queryParams.pagingQuery) {
            queryParams.pagingQuery = {
                pageIndex: 1,
                pageSize: 10,
            }
        }
        InventoryQueryService.queryList(queryParams).then(resp => {
            let data = resp.data;
            if (data.success && data.valid) {
                this.setState({
                    dataStatistics: data.model,
                    dataSource: data.models,
                    loading: false,
                    total: data.paging ? data.paging.total : 0,
                })
            }
        });
    }

    /**
     * 切换面板的回调
     *
     * @param {Number} activeKey 激活面板的索引值
     */
    handleChange = activeKey => {
        // 清空数据源
        this.setState({
            dataSource: [],
            dataStatistics: [],
            activeKey: activeKey
        }, () => {
            // 发起请求
            this.queryList({
                type: activeKey === "1" ? 0 : 1,
            });
        })
    };

    /**
     * 数据查询
     *
     * @param {Object} queryParams 查询参数
     */
    handleQuery = (queryParams) => {
        this.queryList(queryParams);
    }
    render() {
        let {dataSource, dataStatistics, activeKey, total, loading} = this.state;
        return (
            <div className="InventoryQuery">
                <CommonBreadcrumb list={[{name: Lang({id: "KuCunChaXun", default: "库存查询"})}]}/>
                <div className={"mt_20 mb_20"}>
                    <Card>
                        <Tabs defaultActiveKey={activeKey} onChange={this.handleChange}
                              items={[
                                  {
                                      key: '1',
                                      label:(Lang({id: "GongSiKuCun", default: "公司库存"})),
                                      children:(<InventoryCompany onQuery={this.handleQuery} loading={loading} dataStatistics={dataStatistics} dataSource={dataSource} total={total}/>)
                                  },
                                  {
                                      key: '2',
                                      label:Lang({id: "KeHuKuCun", default: "客户库存"}),
                                      children:(<InventoryCustomer onQuery={this.handleQuery} loading={loading} dataStatistics={dataStatistics} dataSource={dataSource} total={total}/>)
                                  }
                              ]}
                        >
                        </Tabs>
                    </Card>
                </div>
            </div>
        );
    }
}

